import { Check, X } from "lucide-react";

import type { FeatureProductCoverage } from "@/infrastructure/supabase/database.types";

interface MatrixCellPickerProps {
  current: FeatureProductCoverage | null;
  onPick: (next: FeatureProductCoverage | null) => void;
  onClose: () => void;
}

const OPTIONS: { value: FeatureProductCoverage; label: string; color: string; bg: string }[] = [
  { value: "native", label: "Native", color: "oklch(0.35 0.16 145)", bg: "oklch(0.93 0.07 145)" },
  { value: "plugin", label: "Plugin", color: "oklch(0.35 0.16 260)", bg: "oklch(0.93 0.06 260)" },
  { value: "custom", label: "Custom", color: "oklch(0.40 0.16 50)", bg: "oklch(0.93 0.09 50)" },
  {
    value: "irrelevant",
    label: "Irrelevant",
    color: "oklch(0.45 0.01 240)",
    bg: "oklch(0.94 0.005 240)",
  },
];

export function MatrixCellPicker({ current, onPick, onClose }: MatrixCellPickerProps) {
  return (
    <div className="flex flex-col gap-1.5 p-2">
      {OPTIONS.map((o) => {
        const active = current === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => {
              onPick(o.value);
              onClose();
            }}
            className="flex items-center justify-between gap-2 rounded-md border px-2.5 py-1.5 text-[12px] font-medium transition-colors"
            style={
              active
                ? { borderColor: o.color, background: o.bg, color: o.color }
                : { borderColor: "oklch(0.91 0.008 240)", color: "oklch(0.45 0.01 240)" }
            }
          >
            <span>{o.label}</span>
            {active ? <Check className="size-3" /> : null}
          </button>
        );
      })}
      <button
        type="button"
        onClick={() => {
          onPick(null);
          onClose();
        }}
        className="flex items-center justify-between gap-2 rounded-md border px-2.5 py-1.5 text-[12px] font-medium text-[oklch(0.55_0.01_240)] transition-colors hover:bg-[oklch(0.96_0.005_240)]"
        style={{ borderColor: "oklch(0.91 0.008 240)" }}
      >
        <span>Clear (not assessed)</span>
        <X className="size-3 opacity-60" />
      </button>
    </div>
  );
}
